module.exports = __webpack_public_path__ + "img/team-driver.9506b8dd.png";